import omit from "lodash/omit";
import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import * as Types from "./types";

export const standardWorkingDayListService = (params: {
  page?: number | null;
  limit?: number | null;
  status?: number | null;
  keyword?: string | null;
}) =>
  RestAPIClient.call<RestAPIResponseList<Types.StandardWorkingDay>>({
    method: HTTPRequestMethods.GET,
    url: Paths.List,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const standardWorkingDayDetailService = (id: string) => {
  return RestAPIClient.call<Types.StandardWorkingDay>({
    method: HTTPRequestMethods.GET,
    url: Paths.Detail.replace("{id}", id),
    config: {
      requireAuthentication: true,
    },
  });
};

export const standardWorkingDayCreateService = (data: {
  effectiveFrom: string;
  calculateMethod: string;
  applicableObject: string;
  workingDayTypeFixed: {
    objectCode: string;
    objectName: string;
    workingDay: number;
    workingHour: number;
    isNew?: boolean;
  }[];
  workingDayEmployeeFixed: {
    empId: string;
    workingDay: number;
    workingHour: number;
    isNew?: boolean;
  }[];
  workingDayTypeActualCalendar: {
    dayOfWeek: number;
    value: number;
    active?: boolean;
  }[];
}) =>
  RestAPIClient.call<RestAPIResponse<Types.StandardWorkingDay>>({
    method: HTTPRequestMethods.POST,
    url: Paths.Create,
    config: {
      requireAuthentication: true,
    },
    data,
  });

export const standardWorkingDayUpdateService = (
  data: Parameters<typeof standardWorkingDayCreateService>[0] & { id: string }
) =>
  RestAPIClient.call<RestAPIResponse<Types.StandardWorkingDay>>({
    method: HTTPRequestMethods.PUT,
    url: Paths.Update.replace("{id}", data.id),
    config: {
      requireAuthentication: true,
    },
    data: omit(data, "id"),
  });
